import OAuth from '../oauth'
import router from '../router/index'
import AuthService from '../oauth/service'
import intersection from 'lodash/intersection'

let oAuth = new OAuth();
let no_of_request = 0;
router.beforeEach(async (to, from, next) => {

    //If visiting login view but you already have logged in, you should not be able to see this view
    if (to.name === 'Login' && oAuth.isAuthenticated()) {
        return next({
            path: '/system'
        })
    }


    //If you are visiting '/' and you are a guest then, you must be redirected to login
    if (to.meta.requiresAuth) {
        if (oAuth.guest()) {
            return next({
                name: 'Login',
                query: {
                    redirect: to.fullPath
                }
            })
        }
    }
    if (to.meta.checkPermission) {
        await AuthService.currentUser().then((res) => {
            if (to.meta.checkPermission.length > 0) {
                let permissions = res.data.data.permissions.map(r => {
                    return r.name;
                });
                let roles = res.data.data.roles[0].name;

                if (roles !== 'Super Admin') {
                    // if()
                    if (intersection(to.meta.checkPermission, permissions).length <= 0) {
                        return next({
                            name: 'AccessDenied',
                            query: {
                                redirect: to.fullPath
                            }
                        })
                    }
                }
            }
        });
    }
    return next()
});
